import { useState } from 'react'

import type { ActionItem, Item, Step } from 'modules/processes/domain'
import { MaterializedItem } from 'modules/processes/domain'

import { useItemProvider } from 'modules/processes/components/ItemWizard/Providers/item'
import ItemForm from 'modules/processes/components/ItemWizard/components/Form/ItemForm'
import { ItemType } from './types'

interface Props {
  item?: Item
  stepId: string
  currentStep: Step
}

export type MaterializedItemsFormValues = Partial<MaterializedItem> & {
  stepId: string | undefined
  access_ids?: string[]
  offset_direction?: string
  offset_amount?: number
  reference_field_key?: string
  assignee_strategy?: string
  location_id?: string
  team_ids?: string[]
  team_lead_team_ids?: string[]
  task_type?: string
  additional_form_data?: Record<string, unknown>
  data_collection_configuration?: Record<string, unknown>
} & Partial<ActionItem>

export const useItemForm = ({ item, stepId, currentStep }: Props) => {
  const [itemsForm, setItemsForm] = useState<Record<ItemType, ItemForm>>(
    {} as Record<ItemType, ItemForm>
  )

  const { itemType } = useItemProvider()

  const setForm = (itemTypeVal: ItemType, values?: Record<string, unknown>) => {
    if (!itemsForm[itemTypeVal]) {
      const form = new ItemForm({
        id: item?.id,
        position: item?.position ?? Number(currentStep?.items?.length) + 1,
        step_id: stepId,
        task_type: itemTypeVal,
        configurationId: item?.configurationId,
        ...values,
      })

      setItemsForm({
        ...itemsForm,
        [itemTypeVal]: form,
      })

      return form
    }

    return itemsForm[itemTypeVal]
  }

  const changeValue = <T extends keyof MaterializedItemsFormValues>(
    key: T,
    value: MaterializedItemsFormValues[T]
  ) => {
    itemsForm[itemType].setValues({ [key]: value })
    setItemsForm((prev) => ({
      ...prev,
      [itemType]: itemsForm[itemType],
    }))
  }

  return {
    form: itemsForm[itemType],
    changeValue,
    setForm,
  }
}
